export enum SALARY_BATCH_STATUS {
	DELIVERED_TO_SYSTEM = "DELIVERED_TO_SYSTEM",
	INITIAL = "INITIAL",
	PREVIEW = "PREVIEW",
	PROCESSED = "PROCESSED",
	PROCESSING = "PROCESSING",
	ROLLED_BACK = "ROLLED_BACK",
	FAILED = "FAILED",
}
